import moment from 'moment-timezone'

export const VACANT_SEAT_PATH = 'VACANT_SEAT'

export function isVacantSeat (seat) {
  return seat.userId === null
}

export function isLeavingSeat (seat) {
  return seat.removalActivateAt !== null
}

export function isChangingPlanSeat (seat) {
  return seat.pendingPlanCode !== null
}

export function formatSeatDate (value) {
  return moment(value).format('DD/MM/YYYY')
}

// A saída da licença vale na virada do ciclo, gravada pelo billing como meia-noite
// UTC do primeiro dia do ciclo novo. Formatar no fuso do navegador mostraria o dia
// anterior; o dia do ciclo é o UTC.
export function formatSeatRemovalDay (value) {
  return moment.utc(value).format('DD/MM/YYYY')
}

export function formatSeatShortDay (value) {
  return moment.utc(value).format('DD/MM')
}

export function formatSeatLastUsableDay (value) {
  return moment.utc(value).subtract(1, 'day').format('DD/MM/YYYY')
}

export function formatSeatShortLastUsableDay (value) {
  return moment.utc(value).subtract(1, 'day').format('DD/MM')
}

// O billing prefere a licença livre que não expira; a que expira só é usada quando
// todas as livres do plano estão expirando. Por plano nessa situação, a data de
// expiração mais próxima entre as livres dele.
export function vacantSeatExpiryByPlanCode (seats) {
  const vacantSeatsByPlanCode = {}
  seats.filter(isVacantSeat).forEach(seat => {
    if (vacantSeatsByPlanCode[seat.planCode] === undefined) {
      vacantSeatsByPlanCode[seat.planCode] = []
    }
    vacantSeatsByPlanCode[seat.planCode].push(seat)
  })
  const expiryByPlanCode = {}
  Object.keys(vacantSeatsByPlanCode).forEach(planCode => {
    const planSeats = vacantSeatsByPlanCode[planCode]
    if (!planSeats.every(isLeavingSeat)) return
    const [earliestSeat] = planSeats.slice().sort((a, b) => moment.utc(a.removalActivateAt).valueOf() - moment.utc(b.removalActivateAt).valueOf())
    expiryByPlanCode[planCode] = earliestSeat.removalActivateAt
  })
  return expiryByPlanCode
}

export function summarizeSeatsByPlan (seats, pricingList) {
  const summaryByPlanCode = {}
  seats.forEach(seat => {
    if (summaryByPlanCode[seat.planCode] === undefined) {
      summaryByPlanCode[seat.planCode] = {
        planCode: seat.planCode,
        plan: seat.plan,
        contracted: 0,
        occupied: 0,
        vacant: 0
      }
    }
    const summary = summaryByPlanCode[seat.planCode]
    summary.contracted++
    if (isVacantSeat(seat)) {
      summary.vacant++
    } else {
      summary.occupied++
    }
  })
  const planOrder = pricingList.map(plan => plan.code)
  const orderOf = planCode => {
    const index = planOrder.indexOf(planCode)
    return index === -1 ? planOrder.length : index
  }
  return Object.values(summaryByPlanCode).sort((a, b) => orderOf(a.planCode) - orderOf(b.planCode))
}



// WEBPACK FOOTER //
// ./src/utils/seats.js